import VoucherFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => <GenericCreateForm formLayoutComponent={<VoucherFormLayout />} transformValues={transformValues} />
